/*******************************************************************************
 * @ngdoc    object
 * @module   csm.books.data
 * @name     csm.books.data.BooksData.type:ItemSalesAcct
 * @constructor
 * @param {object=} info  Item info read from database.
 * @description
 * Item sales account distribution info.
 *******************************************************************************/
/* @ngInject */ export function RunItemSalesAcct(BooksData) {
  BooksData.ItemSalesAcct = function (info) {
    Object.assign(this, info || {});
  };

  BooksData.ItemSalesAcct.prototype = {
    accountID: 0, // Account ID.
    amount: 0, // Distribution amount.
    percentage: 0, // Distribution decimal percentage.

    toJSON: function () {
      var o = {};
      for (var p in this) o[p] = this[p];
      return o;
    }
  };
}
